import { useEffect, useState } from 'react';

import { storeItem } from '../../../helpers/store';
import { initializeVisibleFields } from './utils';

export const useContactVisibleFields = (
  customFields = [],
  {
    isPublicListView = false,
    isTalentNetworkEnabled = true,
    fieldSettings = null,
    storageKey = '',
    isListView = false,
  } = {},
) => {
  const initArgs = {
    isPublicListView,
    isTalentNetworkEnabled,
    fieldSettings,
    storageKey,
    isListView,
  };
  const [visibleFields, setVisibleFields] = useState(() => initializeVisibleFields(customFields, initArgs));

  useEffect(() => {
    setVisibleFields(
      initializeVisibleFields(customFields, {
        isPublicListView,
        isTalentNetworkEnabled,
        fieldSettings,
        storageKey,
        isListView,
      }),
    );
  }, [customFields, fieldSettings, isPublicListView, isTalentNetworkEnabled, isListView, storageKey]);

  useEffect(() => {
    if (storageKey) {
      storeItem(storageKey, JSON.stringify([...visibleFields.entries()]));
    }
  }, [storageKey, visibleFields]);

  return [visibleFields, setVisibleFields];
};
